import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/case-study/CaseStudy.jsx");
